import * as yup from "yup";

export const createYupSchema = (schema, config) => {
  const { fieldName, validationType, validations = [] } = config;
  if (!yup[validationType]) {
    return schema;
  }
  let validator = yup[validationType]();
  validations.forEach((validation) => {
    const { params, type } = validation;
    if (!validator[type]) {
      return;
    }
    validator = validator[type](...params);
  });
  schema[fieldName] = validator;
  return schema;
};
